// Add your custom JS here.
(function ($) {
    // Ensure GSAP ScrollToPlugin is registered
    gsap.registerPlugin(ScrollToPlugin);

    if ($("body").hasClass("page-template-frontpage")) {
        // Select all anchor links that contain a hash (#) in the href, with or without a preceding "/"
        const anchors = document.querySelectorAll('a[href*="#"]'); // Match anchors with #

        // Add click event listener to each anchor
        anchors.forEach((anchor) => {
            anchor.addEventListener("click", function (event) {
                // Prevent the default anchor behavior
                event.preventDefault();

                // Add the "active-flash" class to the .flash element
                const flashElement = document.querySelector(".flash");
                flashElement.classList.add("active-flash");

                // Remove the "active-flash" class after 300ms
                setTimeout(function () {
                    flashElement.classList.remove("active-flash");
                }, 1500);

                // Get the target element's ID from the href (cleaned)
                const targetId = anchor.getAttribute("href").split("#")[1]; // Extract ID after #

                // Ensure the targetId is valid and exists
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    setTimeout(function () {
                        // Smooth scroll to the target element using GSAP
                        gsap.to(window, {
                            scrollTo: {
                                y: targetElement, // Target the actual DOM element
                                autoKill: false, // Prevent GSAP from auto-stopping the scroll
                                offsetY: 0, // Adjust for any fixed headers if needed
                            },
                            duration: 0, // Duration of the smooth scroll (in seconds)
                            ease: "power2.out", // Smooth easing
                        });
                    }, 100); // Delay the scroll by 300ms
                }
            });
        });
    }

    // PAGE TRANSITIONS
    $("a").click(function (event) {
        // Check if the anchor has a target attribute set to "_blank"

        if ($(this).hasClass("notransition")) {
            return;
        }

        if ($(this).attr("target") === "_blank") {
            return; // Do nothing if it has target="_blank"
        }

        // Check if the anchor has a "tel:" or "mailto:" href
        var href = $(this).attr("href");
        if (href.startsWith("tel:") || href.startsWith("mailto:")) {
            return; // Do nothing for tel: and mailto: links
        }

        // Check if the anchor has a "#" href
        if (href.indexOf("#") !== -1) {
            // Do nothing for "#" links, but allow them to work
            return;
        }

        // Prevent the default behavior of the anchor tag
        event.preventDefault();

        // Add the "active" class to the element with class "page-transition-in"
        $(".page-transition-in").addClass("active");

        // Delay navigation by 500 milliseconds
        setTimeout(function () {
            window.location.href = href;
        }, 500);
    });

    // Function to remove the "active" class from "page-transition-in" element
    function removeActiveClass() {
        var element = document.querySelector(".page-transition-in");
        if (element) {
            element.classList.remove("active");
        }
    }

    // Execute the function on page load
    window.addEventListener("load", removeActiveClass);

    // Execute the function on pageshow event (including navigating back in Safari)
    window.addEventListener("pageshow", removeActiveClass);

    $(document).on("click", ".gform_button", function () {
        // Add the "active-flash" class to the .flash element
        const flashElement = document.querySelector(".flash");
        if (flashElement) {
            flashElement.classList.add("active-flash");

            // Remove the "active-flash" class after 1500ms
            setTimeout(function () {
                flashElement.classList.remove("active-flash");
            }, 1500);
        }
    });

    $(".menu-toggle").on("click", function () {
        $(this).toggleClass("active");
        $("#wrapper-navbar .menu").toggleClass("active");
        $("#wrapper-navbar").toggleClass("active");
    });

    $(".menu a").on("click", function () {
        $(".menu-toggle").removeClass("active");
        $("#wrapper-navbar .menu").removeClass("active");
        $("#wrapper-navbar").removeClass("active");
    });

    /////////// HEADER SCROLL FUNCTIONS
    $(document).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 50) {
            $("#wrapper-navbar").removeClass("off-top");
            $(".menu a").removeClass("active");
        }
    });

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });

    if ($("body").hasClass("page-template-frontpage")) {
        // Ensure touch interactions are enabled
        ScrollTrigger.config({
            touch: true,
        });

        ///////// ALWAYS START AT TOP
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }

        // Force scroll to top on page load
        $(window).scrollTop(0);

        /////////// FIX PADDING/NAVBAR AFTER INTRO
        let viewportHeight = window.innerHeight; // 100vh equivalent

        $(window).on("scroll", function () {
            if ($(window).scrollTop() >= viewportHeight) {
                $("#wrapper-navbar").addClass("stick");
                // scrolledOnce = true;
            } else {
                $("#wrapper-navbar").removeClass("stick");
            }
        });

        ///////// GSAP REGISTERS
        gsap.registerPlugin(
            SplitText,
            ScrollTrigger,
            ScrollSmoother,
            ScrollToPlugin
        );

        if (window.innerWidth > 992) {
            // Sticky element trigger
            gsap.to("#wrapper-navbar", {
                scrollTrigger: {
                    trigger: "#wrapper-navbar", // The element that will become sticky
                    start: "top top", // Stick to the top when it hits the top of the viewport
                    pin: true, // Pin the element
                    pinSpacing: true, // Keep the space occupied when it's pinned
                    anticipatePin: 1, // Helps avoid jumping on smooth scroll
                    scrub: false, // Pinning is instant, no scrubbing needed
                    end: "+=500000", // Adjust how long you want it to be pinned (in pixels)
                },
            });

            document.addEventListener("DOMContentLoaded", function () {
                const horizontalSectionInner = document.querySelector(
                    ".horizontal-section-inner"
                );
                const titles = document.querySelector(".titles");
                const maskRevealSection = document.querySelector(
                    ".section-maskreveal"
                );
                const totalWidth = horizontalSectionInner.scrollWidth - 1500;

                // Horizontal scroll for .section-horizontal
                gsap.to(horizontalSectionInner, {
                    x: () => -(totalWidth - window.innerWidth), // Moves horizontally by the total width of content
                    ease: "none",
                    scrollTrigger: {
                        trigger: ".section-horizontal",
                        start: "top top",
                        end: () => `+=${totalWidth}`, // End when horizontal scrolling completes
                        scrub: true, // Smooth linking between scroll and animation
                        pin: true, // Pin the horizontal section while scrolling
                        anticipatePin: 1, // Avoid jank
                    },
                });

                // Parallax effect for the titles
                gsap.to(titles, {
                    xPercent: -20, // Move faster horizontally (-20% faster than the main section)
                    ease: "none", // No easing, for smooth movement
                    scrollTrigger: {
                        trigger: ".section-horizontal", // Same trigger as the main section
                        start: "top top",
                        end: () => `+=${totalWidth}`, // Same duration as the main section
                        scrub: true, // Smooth scroll effect
                    },
                });

                // Determine the mask size multiplier based on viewport width
                const maskSizeMultiplier = window.innerWidth < 992 ? 1000 : 200;

                // Mask Reveal Section (triggered after horizontal scroll)
                gsap.to(".mask", {
                    maskSize: "100%", // Reveal the mask (expanding from 0 to full size)
                    ease: "none", // Link directly to scroll
                    scrollTrigger: {
                        trigger: maskRevealSection, // Trigger the mask reveal section
                        start: "top top", // Start when mask section hits the top of the viewport
                        end: "+=100%", // Continue for 100% of the viewport height
                        scrub: true, // Smooth scrub based on scroll progress
                        pin: true, // Pin the section during mask reveal
                        onUpdate: (self) => {
                            const progress = self.progress * maskSizeMultiplier; // Adjust mask size based on scroll progress
                            gsap.set(".mask", { maskSize: `${progress}%` }); // Dynamically set mask size

                            // Add the class "done" when the progress reaches 100%
                            if (self.progress >= 1) {
                                maskRevealSection.classList.add("done");
                                $(".section-horizontal").addClass("done");
                            } else {
                                maskRevealSection.classList.remove("done");
                                $(".section-horizontal").removeClass("done");
                            }
                        },
                    },
                });
            });

            $(document).ready(function () {
                // Function to calculate and apply margin
                function adjustMargin() {
                    // Get the height of the .section-maskreveal-inner .container element
                    var containerHeight = $(
                        ".section-maskreveal-inner .container"
                    ).outerHeight();

                    // Get the window height
                    var windowHeight = $(window).height();

                    // Calculate the total margin (container height + 256px - window height)
                    var totalMargin = containerHeight + 255 - windowHeight;

                    // Apply the margin-top to the .section-area element
                    $(".section-area").css("margin-top", totalMargin + "px");
                }

                // Call the function on document ready
                adjustMargin();

                // Also call the function on window resize
                $(window).resize(function () {
                    adjustMargin();
                });
            });

            // Pin only the .backtitle in the middle of the viewport while scrolling through .section-image-grid
            gsap.to(".backtitle", {
                scrollTrigger: {
                    trigger: ".section-image-grid", // Trigger the pinning when the section starts
                    start: "top top", // Start pinning when the section starts entering the viewport
                    end: "bottom bottom", // Unpin when the bottom of the section reaches the bottom of the viewport
                    pin: ".backtitle", // Pin only the backtitle element
                    pinSpacing: false, // No extra space for pinning
                    scrub: true, // Smooth pinning
                    anticipatePin: 1, // Helps avoid jumpy behavior
                },
                ease: "none", // No easing to keep smooth pinning
            });

            const targetElement = document.querySelector(
                ".page-template-frontpage #page-inner .section-video .container"
            );

            // Use ScrollTrigger to add and remove the "wider" class
            ScrollTrigger.create({
                trigger: targetElement, // The element to watch
                start: "top+=128px center", // Start when the top of the element hits the center of the viewport
                end: "bottom center", // End when the bottom of the element leaves the center of the viewport
                toggleClass: {
                    targets: targetElement,
                    className: "wider",
                },
            });

            // Select the image slider section
            const slider = document.querySelector(".image-slider");

            // Select all the .block elements
            const blocks = document.querySelectorAll(".image-slider .block");

            // Create a ScrollTrigger for each block
            blocks.forEach((block, i) => {
                gsap.to(block, {
                    scrollTrigger: {
                        trigger: block, // Trigger on each block
                        start: "center center", // Pin the block when it hits the center of the viewport
                        end: () => `+=${slider.offsetHeight + 3000}`, // Keep each block pinned until the entire section is scrolled
                        pin: true, // Pin each block in place
                        pinSpacing: false, // Avoid adding extra space while pinning
                        scrub: true, // Smooth scrolling behavior
                        toggleActions: "play reverse play reverse", // Reverse animation on scroll up
                        onEnter: () => {
                            gsap.to(block, { scale: 0.8, duration: 3 }); // Reset scale when block is in the viewport
                        },
                        onLeave: () => {
                            gsap.to(block, { scale: 0.9, duration: 3 }); // Shrink when it leaves
                        },
                        onEnterBack: () => {
                            gsap.to(block, { scale: 1, duration: 0.3 }); // Scale up when scrolling back
                        },
                        onLeaveBack: () => {
                            gsap.to(block, { scale: 0.9, duration: 0.3 }); // Shrink when leaving in reverse
                        },
                    },
                });
            });

            // Dynamically add extra space at the bottom of the content for smooth scrolling
            const smootherContent = document.querySelector("#page-inner-inner");

            // Calculate and add the necessary padding

            if (window.innerWidth > 992) {
                const extraPadding = window.innerHeight + "px"; // Add 100vh worth of space
                smootherContent.style.paddingBottom = extraPadding;
            }

            // ScrollSmoother setup for desktop only
            ScrollSmoother.create({
                wrapper: "#page-inner",
                content: "#page-inner-inner",
                smooth: 1.5,
                effects: true,
                ignore: ".stick",
            });

            if (window.innerWidth > 992) {
                $(document).ready(function () {
                    $("#zoom-image").blowup();
                });
            }

            // Select all the front images
            // Select all front images
            const frontImages = document.querySelectorAll(".parallax");

            // Loop through each front image and apply the parallax effect based on its class
            frontImages.forEach((frontImage) => {
                let speed = 10; // Default speed

                // Set different speeds based on class
                if (frontImage.classList.contains("fast")) {
                    speed = 17; // Faster parallax
                } else if (frontImage.classList.contains("medium")) {
                    speed = 10; // Medium speed parallax
                } else if (frontImage.classList.contains("slow")) {
                    speed = 3; // Slower parallax
                }

                // Apply the parallax effect using GSAP
                gsap.fromTo(
                    frontImage,
                    { yPercent: speed }, // Start with dynamic speed
                    {
                        yPercent: -speed, // End with dynamic speed
                        ease: "none", // No easing for smooth effect
                        scrollTrigger: {
                            trigger: frontImage, // The image itself is the trigger
                            start: "top bottom", // Start when the top of the image is at the bottom of the viewport
                            end: "bottom top", // End when the bottom of the image reaches the top of the viewport
                            scrub: true, // Smooth scrubbing (links the animation progress to the scrollbar)
                        },
                    }
                );
            });
        }

        /////////////// INTRO ANIMATION STUFF
        let touchStartY = 0;
        let touchEndY = 0;
        let isActive = false; // Flag to track if .active class is already added

        // Function to handle scroll/swipe up actions (changed to swipe up)
        function handleScrollSwipeDown() {
            if (!$(".section-intro-two").hasClass("active") && !isActive) {
                $(".section-intro-two").addClass("active");
                $(".section-intro-one").addClass("no-active");
                setTimeout(function () {
                    $("html, body").addClass("no-lock");
                    isActive = true;
                }, 2000);
            }
        }

        // Detect swipe (for touch devices)
        window.addEventListener(
            "touchstart",
            function (event) {
                if (!isActive) {
                    touchStartY = event.touches[0].clientY;
                }
            },
            { passive: false }
        );

        window.addEventListener(
            "touchmove",
            function (event) {
                if (!isActive) {
                    event.preventDefault(); // Prevent the page from scrolling
                }
            },
            { passive: false }
        );

        window.addEventListener(
            "touchend",
            function (event) {
                if (!isActive) {
                    touchEndY = event.changedTouches[0].clientY;

                    // Detect swipe up (swipe up means touchEndY < touchStartY)
                    if (touchEndY < touchStartY) {
                        handleScrollSwipeDown();
                    }
                }
            },
            { passive: false }
        );

        // Detect scroll (for desktop devices)
        window.addEventListener(
            "wheel",
            function (event) {
                if (!isActive) {
                    // Detect scroll down (event.deltaY > 0 for scroll down)
                    if (event.deltaY > 0) {
                        handleScrollSwipeDown();
                    }
                }
            },
            { passive: true }
        );

        // Adding a scroll event listener for Safari compatibility
        window.addEventListener(
            "scroll",
            function () {
                if (!isActive) {
                    handleScrollSwipeDown();
                }
            },
            { passive: true }
        );

        // Click triggers
        $(".scrolldown, .menu a").on("click", function () {
            if (!isActive) {
                handleScrollSwipeDown();
            }
        });
    }

    if (window.innerWidth < 992) {
        $(".logos").appendTo(".form").parent();
    }
})(jQuery);
